<div style="display: inline-block" class="uxDesignerTemplatePanel">
  <ng-container *ngIf="!model.renameMode">
    <div
      style="
        border-radius: 3px;
        background-color: white;
        display: inline-block;
        padding-top: 0px;
        height: var(--aurora-size-input-height);
        margin-right: 4px;
      "
    >
      <!-- <label for="SelectTemplate">Select Template: </label> -->
      <div style="display: inline-block; width: 140px" class="margin-r-5">
        <ep-dropdown
          name="SelectTemplate"
          class="unity-form-group select"
          [codeValues]="settingListAsCodeSet"
          [(ngModel)]="model.Setting_ID"
          [addOptionIfMissing]="false"
          (ngModelChange)="settingSelected($event)"
          ngbTooltip="Select Template"
        ></ep-dropdown>
      </div>
      <div style="display: inline-block; vertical-align: top; padding-top: 5px">
        <aurora-icon-button
          *ngIf="!noTemplateSelected"
          type="button"
          (click)="startRename('EDIT')"
          ngbTooltip="Edit Template Name"
          icon="pencil"
        ></aurora-icon-button>
        <aurora-icon-button
          *ngIf="!noTemplateSelected"
          type="button"
          (click)="startRename('CLONE')"
          ngbTooltip="Clone Template"
          icon="copy"
        ></aurora-icon-button>
        <aurora-icon-button type="button" (click)="settingSelected('0')" ngbTooltip="New Template" icon="plus"></aurora-icon-button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="model.renameMode">
    <div
      style="
        border: 1px solid white;
        border-radius: 3px;
        background-color: white;
        display: inline-block;
        padding-top: 2px;
        height: var(--aurora-size-input-height);
        margin-right: 4px;
      "
    >
      <input
        #templateName
        name="Title"
        class="margin-r-5"
        [(ngModel)]="model.New_Title"
        (ngModelChange)="pageOS.setDirty()"
        maxLength="80"
        placeholder="Enter Template Name"
        style="border: none"
      />
      <!-- overlay input with buttons    OR wrap input & buttons and drop borders -->

      <div style="display: inline-block; vertical-align: top; padding-top: 1px">
        <aurora-icon-button
          [disabled]="model.New_Title == ''"
          type="button"
          (click)="endRename()"
          ngbTooltip="Update Name"
          icon="checkmark"
          size="large"
        ></aurora-icon-button>
        <aurora-icon-button type="button" (click)="cancelRename()" ngbTooltip="Cancel Rename" icon="times"></aurora-icon-button>
      </div>
    </div>
  </ng-container>
</div>
